const u = (id, w = 900) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

const p = (id, w = 900) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const SITE = {
  name: "Cosmic Salon and Spa",
  shortName: "Cosmic",
  tagline: "Salon & Spa",
  phoneDisplay: "+91 98765 43210",
  phoneHref: "tel:+919876543210",
  whatsapp:
    "https://wa.me/919876543210?text=Hi%20Cosmic!%20I%27d%20like%20to%20book%20an%20appointment.",
  address:
    "582/i, 7th Main Rd, Next to Bisi Bisi Hotel, Vinayaka Layout, 10th Block, Nagarbhavi, Bengaluru – 560072",
  hours: "Mon – Sat · 10:00 AM – 8:00 PM · Sun · 10:00 AM – 7:30 PM",
  rating: "4.5",
  customers: "197+",
  mapEmbed:
    "https://maps.google.com/maps?q=Cosmic%20Salon%20and%20Spa%20Nagarbhavi%20Bengaluru&z=16&ie=UTF8&iwloc=&output=embed",
  directions:
    "https://www.google.com/maps/search/Cosmic+Salon+and+Spa+Nagarbhavi+Bengaluru",
  reviewsUrl:
    "https://www.google.com/maps/search/Cosmic+Salon+and+Spa+Nagarbhavi+Bengaluru",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/31323301/pexels-photo-31323301.png?auto=compress&cs=tinysrgb&w=1800",
  heroFallback: p("7750124", 1800),
};

export const SERVICES = [
  { name: "Haircut", category: "Hair", price: "₹199", desc: "Precision cuts tailored to your face shape and lifestyle, for women and men.", img: u("photo-1552642986-ccb41e7059e7"), alt: "Indian gentleman with a fresh salon haircut" },
  { name: "Hair Styling", category: "Hair", price: "₹349", desc: "Blowouts, curls and occasion-ready styling with premium finishing products.", img: p("17163945"), alt: "Indian woman with freshly styled long hair at the salon" },
  { name: "Hair Colour", category: "Hair", price: "₹999", desc: "Global colour, balayage and highlights using gentle, ammonia-free ranges.", img: p("20046793"), alt: "Indian woman showing her rich new hair colour" },
  { name: "Hair Spa", category: "Hair", price: "₹799", desc: "Deep-conditioning rituals that repair, nourish and restore natural shine.", img: p("3993451"), alt: "Woman enjoying a relaxing hair spa wash" },
  { name: "Keratin Treatment", category: "Hair", price: "₹2,499", desc: "Frizz-control keratin therapy for smooth, manageable, glossy hair.", img: p("10318055"), alt: "Stylist performing a keratin treatment" },
  { name: "Smoothening", category: "Hair", price: "₹1,999", desc: "Long-lasting smoothening for soft, sleek and effortlessly straight hair.", img: p("18367694"), alt: "Indian woman with sleek smoothened layers" },
  { name: "Hair Straightening", category: "Hair", price: "₹1,999", desc: "Professional straightening with heat protection and a silky finish.", img: p("18367697"), alt: "Indian woman with long straightened hair" },
  { name: "Facial", category: "Skin & Beauty", price: "₹699", desc: "Signature facials that cleanse, brighten and deeply hydrate your skin.", img: p("37273224"), alt: "Facial treatment in progress at the spa" },
  { name: "Cleanup", category: "Skin & Beauty", price: "₹399", desc: "A quick, refreshing cleanup to unclog pores and revive tired skin.", img: p("18704463"), alt: "Man getting a refreshing face cleanup" },
  { name: "Skin Treatments", category: "Skin & Beauty", price: "₹999", desc: "Targeted treatments for glow, tan removal, acne care and anti-ageing.", img: p("8867485"), alt: "Relaxing skin treatment with warm towel therapy" },
  { name: "Waxing", category: "Skin & Beauty", price: "₹299", desc: "Gentle full-body waxing with premium wax for smooth, lasting results.", img: u("photo-1544161515-4ab6ce6db874"), alt: "Gentle waxing and body care session" },
  { name: "Threading", category: "Skin & Beauty", price: "₹49", desc: "Perfectly shaped brows and clean facial threading by expert hands.", img: p("34025162"), alt: "Detailed brow and eye work on an Indian client" },
  { name: "Pedicure", category: "Nails", price: "₹499", desc: "Spa pedicures with exfoliation, massage and immaculate nail care.", img: p("34930123"), alt: "Professional pedicure session at the salon" },
  { name: "Manicure", category: "Nails", price: "₹399", desc: "Classic and spa manicures for healthy nails and soft, cared-for hands.", img: p("34930161"), alt: "Nail technician perfecting a manicure" },
  { name: "Bridal Makeup", category: "Makeup", price: "₹9,999", desc: "Bespoke bridal artistry with HD products, trials and pre-bridal packages.", img: u("photo-1622207691293-5cd80466dab3"), alt: "Indian bride with traditional maang tikka and makeup" },
  { name: "Party Makeup", category: "Makeup", price: "₹1,499", desc: "Camera-ready party looks, from soft glam to bold evening statements.", img: p("17125530"), alt: "South Asian glam party makeup look" },
  { name: "Head Massage", category: "Spa & Massage", price: "₹349", desc: "Champi-style head massage with warm oils to melt away stress.", img: p("27497967"), alt: "Indian man enjoying a relaxing head massage" },
  { name: "Spa", category: "Spa & Massage", price: "₹1,299", desc: "Full spa rituals in a calm, aromatic room designed for deep relaxation.", img: u("photo-1560750588-73207b1ef5b8"), alt: "Serene luxury spa room" },
  { name: "Massage", category: "Spa & Massage", price: "₹999", desc: "Therapeutic body massages that ease tension and restore energy.", img: p("6187293"), alt: "Soothing therapeutic massage at the spa" },
];

export const SERVICE_CATEGORIES = [
  "All",
  "Hair",
  "Skin & Beauty",
  "Nails",
  "Makeup",
  "Spa & Massage",
];

export const GALLERY = [
  { img: u("photo-1600948836101-f9ffda59d250", 800), label: "Salon Interior", alt: "Warmly lit luxury salon interior", ratio: "aspect-[4/5]" },
  { img: u("photo-1582095133179-bfd08e2fc6b3", 800), label: "Hair Styling", alt: "Stylist braiding a client's hair", ratio: "aspect-square" },
  { img: u("photo-1610173827043-9db50e0d8ef9", 800), label: "Bridal Makeup", alt: "Indian bride in red and gold attire", ratio: "aspect-[4/5]" },
  { img: "https://images.pexels.com/photos/7195809/pexels-photo-7195809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", label: "Reception", alt: "Elegant salon reception counter", ratio: "aspect-[4/3]" },
  { img: u("photo-1523263685509-57c1d050d19b", 800), label: "Hair Colour", alt: "Glossy professional hair colour result", ratio: "aspect-[4/5]" },
  { img: u("photo-1616394584738-fc6e612e71b9", 800), label: "Facial", alt: "Client enjoying a spa facial", ratio: "aspect-square" },
  { img: u("photo-1540555700478-4be289fbecef", 800), label: "Spa Room", alt: "Calm spa setting with fresh linen", ratio: "aspect-[4/5]" },
  { img: u("photo-1772986367452-cb32c68b7089", 800), label: "Pedicure", alt: "Spa pedicure in progress", ratio: "aspect-[4/3]" },
  { img: u("photo-1580618672591-eb180b1a973f", 800), label: "Hair Spa", alt: "Hair spa ritual at the wash basin", ratio: "aspect-square" },
  { img: u("photo-1503951914875-452162b0f3f1", 800), label: "Professional Team", alt: "Professional stylist at work", ratio: "aspect-[4/5]" },
];

export const REVIEWS = [
  {
    quote:
      "The salon has a relaxing ambience. The staff was friendly and helpful. I had a great experience.",
    name: "Akash",
    source: "Google Review",
  },
  {
    quote:
      "The salon was very clean and hygienic. The staff was friendly and knowledgeable. They helped me choose the right treatments.",
    name: "Prashanth",
    source: "Google Review",
  },
  {
    quote:
      "Customers frequently appreciate the friendly and trained staff, good ambience, hygiene and excellent haircuts and hair spa treatments.",
    name: "Summary",
    source: "Summary of public Google reviews",
  },
];

export const FAQS = [
  {
    q: "Do I need an appointment?",
    a: "Appointments are recommended so we can reserve your preferred stylist and time, especially on weekends. You can book online, call us, or message us on WhatsApp.",
  },
  {
    q: "Can I walk in?",
    a: "Absolutely — walk-ins are welcome every day between 10 AM and 8 PM (till 7:30 PM on Sundays). During peak hours there may be a short wait, so booking ahead is the smoothest experience.",
  },
  {
    q: "Do you offer bridal makeup?",
    a: "Yes. We specialise in bespoke bridal makeup with HD products, pre-bridal packages and trial sessions. Our artists work with you to design a look that feels unmistakably you.",
  },
  {
    q: "Do you offer hair spa treatments?",
    a: "We do — our hair spa rituals use premium masks and serums to repair damage, control frizz and restore shine. Your stylist will recommend the right ritual after a quick hair analysis.",
  },
  {
    q: "What payment methods are accepted?",
    a: "We accept cash, all major UPI apps (GPay, PhonePe, Paytm), and debit/credit cards for a completely hassle-free checkout.",
  },
  {
    q: "What are your working hours?",
    a: "We are open Monday to Saturday from 10:00 AM to 8:00 PM, and Sundays from 10:00 AM to 7:30 PM — including most public holidays.",
  },
];

export const TIME_SLOTS = [
  "10:00 AM", "11:00 AM", "12:00 PM",
  "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
  "06:00 PM", "07:00 PM",
];
;
